/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';

export const LabelStyle = styled.label`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
  margin-bottom: 0px;
`;

const Label = ({
  text = '',
  maxWidth = 0,
  style = {},
  onClick = () => { }
}) => {
  const ref = useRef();
  const [isEllipsis, setIsEllipsis] = useState(false);

  useEffect(() => {
    const e = ref.current;
    if (e.offsetWidth < e.scrollWidth) {
      setIsEllipsis(true);
    } else if (isEllipsis) {
      setIsEllipsis(false);
    }
  }, [maxWidth]);

  const textComp = useMemo(() => (
    <LabelStyle
      style={{ ...style, maxWidth }}
      ref={ref}
      onClick={onClick}
    >
      {text ? typeof text === 'object' ? Object.values(text)[0] || '' : text : '-'}
    </LabelStyle>
  ), [text, maxWidth, style, onClick]);

  return isEllipsis ? (
    <Tooltip title={text}>
      {textComp}
    </Tooltip>
  ) : textComp;
};

export default Label;
